export default __webpack_public_path__ + "static/nuclei-d87d9265c7f32f7bd009c1a4ac8111ed.png";